import moment from "moment";
import { v4 as uuidv4 } from "uuid";

export function Type({ id, form_view, model, responsible }) {
    this.id = id;
    this.name = form_view;
    this.model = model;
    this.responsible = responsible;
}

export function Item(item) {
    this.id = item.id;
    this.name = item.name;
    this.description = item.description;
    this.model = item.model;
    this.serialNumber = item.guid;
    this.responsible = item.responsible;
    this.cost = item.cost;
    this.files = item.inventoryFiles;
    this.category = item.category || {};
    this.subcategory = item.subcategory || {};
    this.type = item.type || {};

    this.issuer = {
        id: null,
        name: null,
    };

    if (item.authorWorker) {
        this.issuer.id = item.authorWorker.id;
        this.issuer.name = item.authorWorker.name;
    } else if (item.authorUser) {
        this.issuer.name = item.authorUser.username;
    }

    this.issuedAt = item.change_status_date;
    this.willExpireAt = item.exp_date ? moment(item.exp_date, "DD.MM.YYYY") : null;

    if (this.willExpireAt) {
        if (moment() > this.willExpireAt) {
            this.isExpired = true;
        }

        this.willExpireAt = this.willExpireAt.format("DD.MM.YYYY");
    } else {
        this.isExpired = false;
    }

    this.status = "Выдан";

    if (this.isExpired) {
        this.status = "Выдан, просрочен";
    }
}

export function Entry({ type, inventory = null }) {
    this.isIssued = false;
    this.isExpired = false;

    this.type = new Type(type);
    this.item = {};

    this.key = uuidv4();

    if (inventory) {
        this.item = new Item(inventory);

        this.isIssued = true;
        this.isExpired = this.item.isExpired;
    }
}

export function Category({ name, items = [], subcategories = {} }) {
    this.name = name;
    this.key = uuidv4();
    this.hasItems = false;
    this.hasExpired = false;
    this.hasUnissued = false;

    this.entries = [];
    this.subcategories = [];

    if (items.length > 0) {
        this.hasItems = true;

        this.entries = items.map(item => new Entry(item));

        this.hasExpired = this.entries.some(item => item.isExpired);
        this.hasUnissued = this.entries.some(item => !item.isIssued);
    }

    if (!Array.isArray(subcategories)) {
        subcategories = Object.values(subcategories);
    }

    if (subcategories.length > 0) {
        this.subcategories = subcategories.map(subcategory => new Category(subcategory));

        this.hasItems = this.subcategories.some(subcategory => subcategory.hasItems);
        this.hasExpired = this.subcategories.some(subcategory => subcategory.hasExpired);
        this.hasUnissued = this.subcategories.some(subcategory => subcategory.hasUnissued);
    }

    this.isExpanded = true;
}

export function Position({ postCode = "other", postName, categories = {} }) {
    this.id = postCode;
    this.name = postName;
    this.hasItems = false;
    this.hasExpired = false;
    this.hasUnissued = false;

    this.categories = [];

    if (!Array.isArray(categories)) {
        categories = Object.values(categories);
    }

    if (categories.length > 0) {
        this.categories = categories.map(category => new Category(category));

        this.hasItems = this.hasItems || this.categories.some(category => category.hasItems);
        this.hasExpired = this.categories.some(category => category.hasExpired);
        this.hasUnissued = this.categories.some(category => category.hasUnissued);
    }
}

export function Inventory(positions = []) {
    this.positions = positions.map(position => new Position(position));
    this.hasItems = this.positions.some(category => category.hasItems);
}

export function HistoryEntry(entry) {
    this.id = entry.id;
    this.positions = entry.post;
    this.status = entry.status;
    this.author = entry.author;
    this.date = entry.date;
    this.comment = entry.comment;
    this.files = entry.inventoryHistoryFiles;

    this.item = new Item(entry.inventory || {});
}

export function History(entries = []) {
    this.entries = entries.map(entry => new HistoryEntry(entry));
}